import Create from './Create'
import Edit from './Edit'
import Detail from './Detail'

export default {
  Create,
  Edit,
  Detail
}
